(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wp-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-wp-cookie-preferences]');
    if (!button) return;
    const errorMessage = button.closest('.wp-footer').querySelector('[data-wp-cookie-error]');
    button.disabled = true;
    errorMessage.hidden = true;
    try {
      if (!window.privacyBanner?.showPreferences) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }
      await window.privacyBanner.showPreferences();
    } catch {
      errorMessage.hidden = false;
    } finally {
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
